var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('admin-vehicles-form',{attrs:{"adminType":"staff","formMode":_vm.formMode,"vehicleId":_vm.vehicleId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }